import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { AuthenticationService } from '../services/authentication.service';
import { Login, AccountType } from '../model/loginmodel';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  accounts: AccountType[] = [
  {
    value: 'tecOrderTokenEndpoint',
    display: 'use Order Account'
  },
  {
    value: 'bdTokenEndpoint',
    display: 'use BusDir Account'
  }];
  model: Login = <Login>{
    username: '',
    password: '',
    accountType: 'TecOrder'
  };
  accountType = 'tecOrderTokenEndpoint';
  loading = false;
  error = '';

  constructor(private router: Router, private service: AuthenticationService) {
  }

  ngOnInit() {
    this.service.logout();
  }

  onAccountTypeChanged(event) {
    this.accountType = event.currentTarget.id;
  }

  login() {
    console.debug(this.model.accountType);
    this.loading = true;
    this.service.login(this.model.username, this.model.password, this.accountType)
      .subscribe(result => {
        if (result === true) {
          this.router.navigate(['/']);
        } else {
          this.error = 'Username or password incorrect';
          this.loading = false;
        }
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/login/login.component.ts